import { useFormContext } from "react-hook-form";
import LabeledSelect from "../../../UniversalEditModal/components/LabeledSelect";

interface Props {
    label: string;
    optionsName: string;
    selectedName: string;
    formName: string;
}

export default function PrivacySelect({
    label,
    optionsName,
    selectedName,
    formName,
}: Props) {
    const { watch, setValue } = useFormContext();

    const options = watch(optionsName) || [];
    const selected = watch(selectedName);

    const getLabel = (list: { value: string; label: string }[], v: string) =>
        list?.find((o) => o.value === v)?.label || v || "";

    return (
        <LabeledSelect
            label={label}
            value={getLabel(options, selected)}
            options={options}
            setValue={setValue}
            formName={formName}
            classes={{
                select: "universaleditmodal-right-content-select",
                select_wrapper: "universaleditmodal-right-content-region",
                select_option: "universaleditmodal-right-content-region-option",
                select_value: "universaleditmodal-right-content-region-value",
            }}
        />
    );
}
